import ParsingService from '../parsing-service';

import {
	INSERT_DATA_DELIMITER_PREFIX as PREFIX,
	INSERT_DATA_DELIMITER_SUFFIX as SUFFIX,
	DATA_CHIP_HTML_TAG,
	MULTI_SELECT_CHIP_HTML_TAG,
} from './data-chip.const';
import { TEXT_PARSER_DELIMITER_PREFIX, TEXT_PARSER_DELIMITER_SUFFIX, TEXT_PARSER_HTML_TAG } from './data-chip.const';

import { excludedAttrsList } from '../HtmlAttributes/html-document-service';

/* Private */

function getSuffixPrefixAndHtmlTag(isTemplateMode) {
	const prefix = isTemplateMode ? TEXT_PARSER_DELIMITER_PREFIX : PREFIX;
	const suffix = isTemplateMode ? TEXT_PARSER_DELIMITER_SUFFIX : SUFFIX;
	const chipHtml = isTemplateMode ? TEXT_PARSER_HTML_TAG : DATA_CHIP_HTML_TAG;
	return { prefix, suffix, chipHtml };
}

function replaceAllDelimitedDataToTipTapFormat(content, nodeId, options, config, isTemplateMode, paramKey) {
	const getContentFunction = (delimitedContent) => ({
		content: delimitedContent,
		mode: delimitedContent.includes('__') ? 1 : 2, // todo - might falsy think that value is from previousStep if column header has '__' in it,
		options,
		nodeId,
		config,
		paramKey,
	});
	const { prefix, suffix, chipHtml } = getSuffixPrefixAndHtmlTag(isTemplateMode);

	const replaceFunc = (tokenizedContent) =>
		ParsingService.replaceAllDelimitedDataToTipTapFormat(prefix, suffix, chipHtml, tokenizedContent, getContentFunction, paramKey);
	const result = ParsingService.tokenizeHtmlAttributesAndRun(excludedAttrsList, content, replaceFunc);
	return result;
}

function tiptapHtmlToString(content, isRichTextEnabled, isTemplateMode) {
	const { prefix, suffix, chipHtml } = getSuffixPrefixAndHtmlTag(isTemplateMode);
	const htmlWithBraces = ParsingService.htmlTagsToCustomDelimiters(prefix, suffix, chipHtml, content);
	return htmlWithBraces;
}

function filterTextOutsideOfTags(taggedData) {
	return ParsingService.filterUndelimitedCharacters(PREFIX, SUFFIX, taggedData);
}
function getLastTag(taggedData) {
	return ParsingService.getLastDelimitedContent(PREFIX, SUFFIX, taggedData);
}

function getMultiSelectChipHtml(multiSelectDisplayData, paramKey = '') {
	if (multiSelectDisplayData) {
		const normalDisplayValueArr = multiSelectDisplayData.split(', ');
		const multiSelectTags = normalDisplayValueArr.map(
			(multiSelectItem) =>
				`<${MULTI_SELECT_CHIP_HTML_TAG} value="${multiSelectItem}" paramKey="${paramKey}" text="${multiSelectItem}"> </${MULTI_SELECT_CHIP_HTML_TAG}>`
		);
		return multiSelectTags.join(' ');
	} else {
		return multiSelectDisplayData;
	}
}

/* Public */

function toTiptapFormat(content, nodeId, options, config, showMultiSelectChips, paramKey, isTemplateMode) {
	if (showMultiSelectChips) {
		return getMultiSelectChipHtml(content, paramKey);
	} else {
		return replaceAllDelimitedDataToTipTapFormat(content, nodeId, options, config, isTemplateMode, paramKey);
	}
}

function fromTiptapFormat(content, readonly, multipleSelection, isRichTextEnabled, isTemplateMode) {
	let newValue = tiptapHtmlToString(content, isRichTextEnabled, isTemplateMode);

	if (readonly) {
		// readonly actually means "only tagged data input" - we manually remove other input
		if (multipleSelection) {
			newValue = filterTextOutsideOfTags(newValue);
		} else {
			newValue = getLastTag(newValue);
		}
	}
	return newValue;
}

const DataChipService = {
	fromTiptapFormat,
	toTiptapFormat,
};

export default DataChipService;
